/**
 * One package, two apps. `__APP_TARGET__` is a build-time literal (vite.config.ts `define`), so
 * only the matching bootstrap survives into the bundle: the admin build carries none of the
 * driver/provider pages and the public build carries none of the admin panel.
 */
if (__APP_TARGET__ === 'admin') {
  void import('./admin/admin.bootstrap');
} else {
  void import('./app/public.bootstrap');
}
